import store from "../../index";

import { FrendsElementStore } from ".";
import { IElementDictionary } from "../IProcessData";

export default class ReduxFrendsElementStore implements FrendsElementStore {
    public getElements(): IElementDictionary {
        return store.getState().elements;
    }
}
